export const CATEGORIES = [
  { id: 'all', name: 'All Ideas' },
  { id: 'markets', name: 'Markets', subcategories: ['us_markets', 'global_markets', 'commodities', 'forex'] },
  { id: 'crypto', name: 'Crypto', subcategories: ['bitcoin', 'ethereum', 'altcoins', 'defi', 'nfts'] },
  { id: 'tech', name: 'Tech', subcategories: ['ai_ml', 'big_tech', 'gaming', 'social_media'] },
  { id: 'finance', name: 'Finance', subcategories: ['federal_reserve', 'banking', 'interest_rates', 'inflation'] },
  { id: 'sports', name: 'Sports', subcategories: ['football_soccer', 'nfl', 'nba', 'mlb', 'nhl', 'tennis', 'golf', 'mma_ufc', 'boxing', 'cricket', 'rugby', 'formula_1', 'olympics', 'esports'] },
  { id: 'science', name: 'Science', subcategories: ['space', 'climate', 'medicine', 'physics'] },
  { id: 'economics', name: 'Economics', subcategories: ['gdp', 'employment', 'trade', 'recession'] },
  { id: 'world_events', name: 'World Events', subcategories: ['elections', 'geopolitics', 'conflicts', 'diplomacy'] },
  { id: 'culture', name: 'Culture', subcategories: ['movies', 'tv_shows', 'music', 'awards'] },
  { id: 'pop_culture', name: 'Pop Culture', subcategories: ['celebrities', 'viral_trends', 'social_media', 'memes'] },
  { id: 'black_culture', name: 'Black Culture', subcategories: ['entertainment', 'sports', 'business', 'politics'] },
  { id: 'urban_culture', name: 'Urban Culture', subcategories: ['hip_hop', 'fashion', 'streetwear', 'sneakers'] },
  { id: 'continents', name: 'Continents', subcategories: ['north_america', 'south_america', 'europe', 'asia', 'africa', 'oceania', 'middle_east'] },
];

export const OUTCOME_TYPES = [
  { id: 'binary', name: 'Yes / No', description: 'Standard binary outcome' },
  { id: 'triple', name: 'Win / Lose / Draw', description: 'For sports with ties (soccer, etc.)' },
];

export const EXPIRY_OPTIONS = [
  { id: '7days', name: '7 Days', days: 7 },
  { id: '30days', name: '30 Days', days: 30 },
  { id: '3months', name: '3 Months', days: 90 },
  { id: '6months', name: '6 Months', days: 180 },
  { id: '1year', name: '1 Year', days: 365 },
  { id: '2years', name: '2 Years', days: 730 },
  { id: 'custom', name: 'Custom Date', days: null },
];
